import * as React from "react"
import { InputAdornment } from "@mui/material"
import { AutocompleteAjaxSeeker, FlagsIconSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { country } from "@signals"


export default function DIPCompareSite({targetSignal, optionsSignal, label='First Retailer', filters={}, ...props}) {
    const selectedOption = optionsSignal.value.find(op => op.value === targetSignal.value)

    const inputProps = {
        startAdornment: selectedOption?.country ? <InputAdornment position="start" sx={{ ml: 2, mt: .5, flexShrink: 0 }}>
            <FlagsIconSeeker countryName={selectedOption.country} />
        </InputAdornment> : null
    }

    return <AutocompleteAjaxSeeker
        multiple={false}
        urlAjax={`${WEBBACK_V2_API}/master-data/site/options`}
        filters={{ country: country.value, ...filters }}
        label={label}
        placeholder="All Retailers"
        value={targetSignal.value}
        onFinishAjax={ops => optionsSignal.value = ops}
        inputProps={inputProps}
        onChange={e => {
            targetSignal.value = e.target.value
        }}
        formatOptionLabel={({ label, country }) => {
            return <LabelCountry country={country} label={label} />
        }}
        {...props}
    />
}